import {get, post} from "@/config/api";

const state = {
  unreadData: {},
  updateTime: 0,
};

const getters = {
};

const mutations = {
};

const actions = {
  GetFeedbackData({}, params) {
    return new Promise((resolve, reject) => {
      get(`feedback/get/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  PostFeedbackData({}, params) {
    return new Promise((resolve, reject) => {
      post(`feedback/post/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetFeedbackUnreadCount({}, params) {
    return new Promise((resolve, reject) => {
      get(`feedback/get_unread_count/`, params).then((data) => {
        state.updateTime = Math.floor(Date.now() / 1000)
        state.unreadData = data
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetCachedFeedbackUnreadCount({}, params) {
    return new Promise((resolve, reject) => {
      if (Math.floor(Date.now() / 1000) - state.updateTime < 15 && state.unreadData && state.unreadData.code === 0) {
        resolve(state.unreadData)
      } else {
        get(`feedback/get_unread_count/`, params).then((data) => {
          state.updateTime = Math.floor(Date.now() / 1000)
          state.unreadData = data
          resolve(data)
        }, (err) => {
          reject(err)
        })
      }
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
